import React from 'react';
import { Row, Col } from 'antd';
// import img from '../../assets/hands-creative-grass-moss.jpg';
import bg from '../../assets/method.png';

const intl = {
  headline: {
    'en': 'HOW WE DO IT',
    'dk': 'HVORDAN VI GØR DET'
  },
  body: {
    'en': <div>
      <b style={{color: '#1abc9c'}}>Organizations</b><br/>When we work with a client we do so with a clear understanding of the organization as a system. Our point of departure is always to explore what serves the organization best.
      <br/><br/>
      <b style={{color: '#1abc9c'}}>Groups</b><br/>Organizations consist of groups and the relationships within and between them. These determine the quality of the group’s ability to fulfill tasks and solve problems. We work diligently with the relationships.
      <br/><br/>
      <b style={{color: '#1abc9c'}}>Individuals</b><br/>Individuals who hold different roles make up groups. Some roles are taken and some are given. Some are formal, some informal; some conscious, some unconscious. All variants influence how we work. We map these interpersonal relationships, their dynamics and influences. We take into consideration the individual, the organization and the task.
    </div>,
    'dk': <div>
    <b style={{color: '#1abc9c'}}>Organisation;</b><br/>Når vi arbejder med en klient – uanset hvilket niveau vi adresserer, så gør vi det på baggrund af en forståelse af organisationen som et system. Vores udgangspunkt er altid hvad tjener organisationen bedst muligt.
    <br/><br/>
    <b style={{color: '#1abc9c'}}>Gruppe;</b><br/>Organisationer består af grupper og deres relationer – både internt i gruppen og mellem grupper. Det er det, der afgør kvaliteten af gruppens opgaveløsning. Vi arbejder målrettet med de relationelle forhold med henblik på at skabe optimal åbenhed, tillid og nysgerrighed.
    <br/><br/>
    <b style={{color: '#1abc9c'}}>Individ;</b><br/>Individer indgår i grupper og får forskellige roller – nogle tager man og andre bliver givet en. Formelle og uformelle. Bevidst eller ubevidst. Alle varianter har indflydelse på vores evne til at løse vores opgave. Vi kortlægger disse dynamikker og hvad de betyder – for individet, for organisationen og for opgaven.
  </div>
  }
}

function ImageBlock({ id, img, headline, body, invertColors, language, displayReadMore, readMoreLink, buttonTxt, maxHeight }) {
  return (
    <Row style={{ backgroundColor: '#fff', color: '#000', paddingTop: '50px' }}>
      <Col sm={24} md={{ span: 16, offset: 4 }}>
        <Row>

          <Col sm={24} md={{ span: 12 }} style={{ position: 'relative', height: '100%' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'left',
                height: '500px',
                textAlign: 'left',
              }}
            >
              <div className="blog_block_content">
                <h2
                  style={{
                    fontSize: '20px',
                    letterSpacing: '1px',
                    lineHeight: '25px',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    color: '#1abc9c'
                  }}
                >
                  {intl.headline[language]}
                </h2>
                <p
                  style={{
                    color: '#8c8c8c',
                    marginBottom: '25px',
                    maxHeight: maxHeight || '350px',
                    fontSize: '14px',
                    // whiteSpace: 'nowrap',
                    // overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intl.body[language]}
                </p>
              </div>
            </div>
          </Col>
          <Col
            sm={24}
            md={{ span: 12 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: '500px',
              justifyContent: 'center',
              paddingLeft: '50px',
            }}
          >
            <div
              style={{
                height: '100%',
                width: '100%',
                border: '10px solid transparent',
                background: `url(${bg}) no-repeat center center`,
                backgroundSize: 'contain',
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default ImageBlock;

ImageBlock.defaultProps = {
  headline: 'Headline about something?',
  body: 'iLead is the blalbalbl balbl ab blablalbalb labla',
  img: bg,
  displayReadMore: false,
};



// WEBPACK FOOTER //
// ./src/pages/Methodology/ImageBlock.js